import ResendOtpButton from "./resend-otp-button.container";

export default ResendOtpButton;